import React, { useContext, useState, useCallback, useEffect } from 'react'
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import BulkReviewsContext, { type BulkReviewsContextType } from '../context';
import { getAsset } from '@helper/getConfigValues'
import scss from '../BulkReviews.module.scss';

const ReviewAndWin = () => {
    const { reviews } = useContext<BulkReviewsContextType>(BulkReviewsContext)
    const [progressBarWidth, setProgressBarWidth] = useState<number>(0);
    const [noOfTickets, setNoOfTickets] = useState<number>(0);
    const [noOfReviews, setNoOfReviews] = useState<number>(0);

    const calculateNoOfTickets = useCallback((noOfReviews: number) => {
        let tickets = 0;
        let progressBar = 0;
        const bonusTickets = 25;
        if(noOfReviews > 0) {
            tickets = noOfReviews * 5;
            progressBar = noOfReviews * 10;
        }

        if(noOfReviews >=5 ) {
            tickets += bonusTickets;
        }

        if(noOfReviews >= 10) {
            tickets += bonusTickets;
        }

        if(progressBar > 100) {
            progressBar = 100;
        }

        setNoOfTickets(tickets);    
        setProgressBarWidth(progressBar < 100 ? progressBar : 100);
    }, [noOfTickets]);

    useEffect(() => {
        const completedReviews = reviews.filter((r) => r.complete && r.supplierId > 0).length;
        setNoOfReviews(completedReviews);
        calculateNoOfTickets(completedReviews);
    }, [reviews, calculateNoOfTickets])
    
    return (
        <>
            <Card className={scss.reviewAndWinContainer} data-testid="reviewAndWin">
                <Card.Body className="ps-4 pt-5 pb-5 pe-4">
                    <div className="text-center">
                        <div className={scss.reviewInfoIcon}>
                            <a href='#' className={scss.sidebarInfobtn} data-bs-toggle='modal' data-bs-target='#reviewSupplierInfoModal'>
                                <Icon icon={faInfoCircle} width={25} />
                            </a>
                        </div>
                        <h4><strong>Review and Win!</strong></h4>
                        <div>Every supplier review you submit gives you 5 tickets for the chance to WIN a $2,500 cash prize</div>
                        <div className={scss.compProgressBar}>
                            <span data-testid="compProgressBar" className={scss.compCurrentTrack} style={{width: `${progressBarWidth}%`}}></span>
                            <img src={getAsset("images/reviews/icon-comp-entries.svg")} className={scss.compBonus0} width="40" height="30"/>
                            <span data-testid="plusTwentyFiveBonus" className={`${scss.compBonus5} ${noOfReviews >= 5 ? scss.success : ''}`}>+25</span>
                            <span className={`${scss.compBonus10} ${noOfReviews >= 10 ? scss.success : ''}`}>+50</span>
                        </div>
                        <div className="mt-2 mb-3">
                            <strong><span data-testid="noOfReviews">{noOfReviews}</span> REVIEWS | <span data-testid="noOfTickets">{noOfTickets}</span> TICKETS</strong>
                        </div>
                        <div className={scss.reviewInfoBonusText}><strong>BONUS!</strong> Submit 5 supplier reviews and receive 25 extra tickets or 10 Supplier reviews you'll get 50 extra tickets!</div>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default ReviewAndWin